import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MultipleStopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"multiple_stop"}/>
}
